import Navbar from "./shared/Navbar";
import { ToastContainer } from "react-toastify";
import { Route, Routes, useNavigate } from "react-router-dom";
// import Login from "./components/Login";
import "react-toastify/dist/ReactToastify.css";
// import AddForm from "./components/AddForm";

import ErrorLogo from "./assets/404.webp";

function App() {
  const navigate = useNavigate();
  const homeHandler = () => {
    navigate("/");
  };

  return (
    <>
      <ToastContainer 
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={"bounce"}
      />

      <Routes>
        <Route path="/" element={<Navbar />} />
        <Route
          path="*"
          element={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                background: "rgb(248 248 248)",
              }}
            >
              <img
                src={ErrorLogo}
                alt=""
                style={{ height: "100vh", cursor: "pointer" }}
                onClick={homeHandler}
              />
            </div>
          }
        />
        {/* <Route path="/login" element={<Login />} />
        <Route path="/addNewForm" element={<AddForm />} /> */}
      </Routes>
    </>
  );
}

export default App;
